import { useMutation, useQueryClient } from "@tanstack/react-query";

import { sadieSimulatorThreadQueryKey } from "@/hooks/queries/useGetSadieSimulatorThread";
import { guacHttpClient } from "@/lib/http";
import { SadieSimulatorTapbackRequest } from "@/types";

// A tapback as the tester on one of Sadie's texts.
export function useCreateAddSadieSimulatorTapback() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: SadieSimulatorTapbackRequest) => {
      await guacHttpClient.post("relationships/simulator/tapback", request);
    },
    onSuccess: (_data, { talentId }) => {
      void queryClient.invalidateQueries({
        queryKey: sadieSimulatorThreadQueryKey(talentId),
      });
    },
  });
}
